import { useQuery } from '@tanstack/react-query';
import { fetchProducts, fetchProductByHandle, fetchProductsByCollection, ShopifyProduct, isShopifyConfigured } from '@/lib/shopify';

export function useShopifyProducts(limit: number = 20, query?: string) {
  const configured = isShopifyConfigured();
  return useQuery<ShopifyProduct[]>({
    queryKey: ['shopify-products', limit, query],
    queryFn: () => fetchProducts(limit, query),
    enabled: configured,
    staleTime: 1000 * 60 * 5,
    meta: { shopifyConfigured: configured },
  });
}

export function useShopifyProduct(handle: string) {
  const configured = isShopifyConfigured();
  return useQuery({
    queryKey: ['shopify-product', handle],
    queryFn: () => fetchProductByHandle(handle),
    enabled: !!handle && configured,
    staleTime: 1000 * 60 * 5,
    meta: { shopifyConfigured: configured },
  });
}

/** Fetch products from a Shopify collection by handle */
export function useShopifyCollection(collectionHandle: string | undefined, limit: number = 50) {
  const configured = isShopifyConfigured();
  return useQuery<ShopifyProduct[]>({
    queryKey: ['shopify-collection', collectionHandle, limit],
    queryFn: () => fetchProductsByCollection(collectionHandle!, limit),
    enabled: !!collectionHandle && configured,
    staleTime: 1000 * 60 * 5,
    meta: { shopifyConfigured: configured },
  });
}

/** Check if Shopify env is configured (for components to distinguish config-missing vs empty) */
export { isShopifyConfigured } from '@/lib/shopify';
